import React, {useState, useContext} from 'react'

import officeStart from '../../images/locations/office.jpg'
import officeStage1 from '../../images/locations/officeButtons.jpg'
import officeStage2 from '../../images/locations/officeBookcase.jpg'

import libraryStart from '../../images/locations/library.jpg'
import libraryStage1 from '../../images/locations/libraryPaintingOpen.jpg'

import laboratoryStart from '../../images/locations/laboratory.jpg'
import laboratoryStage1 from '../../images/locations/laboratoryBox.jpg'

import fourJokersStart from '../../images/locations/fourJokers.jpg'
import fourJokersStage1 from '../../images/locations/fourJokersDoor.jpg'
import fourJokersStage2 from '../../images/locations/fourJokersPanel.jpg'
import fourJokersStage3 from '../../images/locations/fourJokersSafe.jpg'

import lastStandStart from '../../images/locations/lastStand.jpg'
import lastStandStage1 from '../../images/locations/lastStandSwitches.jpg'

import {LocationPuzzlesContext} from '../../context/LocationPuzzlesContext'

function LocationImage({location}) {
    const {locationStage} = useContext(LocationPuzzlesContext)
    const [imageIndex] = useState({
        office: {
            img: [officeStart, officeStage1, officeStage2],
            alt: "the professor's office"
        },
        library: {
            img: [libraryStart, libraryStage1], 
            alt: "a grand study room in the city Library"
        },
        laboratory: {
            img: [laboratoryStart, laboratoryStage1], 
            alt: "the professor's laboratory"
        },
        fourJokers: {
            img: [fourJokersStart, fourJokersStage1, fourJokersStage2, fourJokersStage3], 
            alt:"the four jokers gambling den"
        },
        lastStand: {
            img: [lastStandStart, lastStandStage1], 
            alt:"A warehouse down by the docks"
        }
    })
    
    const {img, alt} = imageIndex.[location]

    return <img className="locationImg" src={img[locationStage]} alt={alt} />
}


export default LocationImage